import './styles.scss';
import {
  Button,
  Heading,
  Text,
  TextField,
  SelectField,
} from '@payourse/style-guide';
import Container from './Container';
import { useProfileContext } from '../context';
import { fields } from '../utils';

export function About() {
  const {
    state,
    incrementStep,
    handleChange,
    handleSelectChange,
  } = useProfileContext();

  return (
    <Container>
      <div className="Profile__description">
        <Heading
          element="h3"
          size="xl"
          text="Tell us a little about yourself"
          className="Profile__title"
        />
        <Text
          size="m"
          weight="normal"
          text="We’ll help you get started based on your responses"
        />
      </div>

      {Object.values(fields.about).map(field => {
        if (field.type === 'select') {
          return (
            <SelectField
              {...field}
              options={field.options!}
              key={field.name}
              value={state[field.name]}
              className="Profile__field"
              onChange={handleSelectChange}
            />
          );
        }

        return (
          <TextField
            {...field}
            key={field.name}
            value={state[field.name]}
            className="Profile__field"
            onChange={handleChange}
          />
        );
      })}

      <div className="Profile__actions">
        <Button variant="outline" onClick={incrementStep}>
          Skip
        </Button>
        <Button variant="secondary" onClick={incrementStep}>
          Continue
        </Button>
      </div>
    </Container>
  );
}
